module.exports = __webpack_public_path__ + "assets/public/imgs/logos/rh-integration.svg";